import moment from 'moment';
import { useEffect, useState } from 'react';

export const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const DATE_FORMAT = 'YYYY-MM-DD'

export const COUNTRY_CODE_PREFIX = '+'

export const getFormatedPhoneAndCountryCode = (phone, countryPhoneCodes) => {
  if (!phone || !countryPhoneCodes || !phone.startsWith('+')) return { phone };
  
  if (phone.startsWith('+')) {
    const matchingCode = countryPhoneCodes.map(c => '+' + c.PhoneCountryCode).find(c => phone.startsWith(c));
    return { phone: phone.replace(matchingCode, '').replace(/ /g, '').trim(), phoneCountryCode: matchingCode };
  } else if (phone.startsWith('00')) {
    const matchingCode = countryPhoneCodes.map(c => '00' + c.PhoneCountryCode).find(c => phone.startsWith(c));
    return { phone: phone.replace(matchingCode, '').replace(/ /g, '').trim(), phoneCountryCode: matchingCode.replace('00', COUNTRY_CODE_PREFIX) };
  }
  return { phone }
}

export const getQueryStringParams = (queryString) => {
  return queryString ?
      queryString.substring(1)
        .split('&')
        .map(p => {
          const parts = p.split('=')
          return parts && parts.length === 2 ? { [parts[0]]: parts[1] } : {}
        })
        .reduce((prev, curr) => ({ ...prev, ...curr }), {})
      : null
}

export function validPortugueseDriversLicence(number) {
  return /^[a-zA-Z]{1,2}-\d{1,7} \d{1}$/g.test(number) 
}

export function isPortugalCountry(country) {
  return country === 'Portugal'
}

export function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function isSafetyExtra(extraId) {
  return ['TP', 'CDW', 'ACDW', 'ACDW1', 'ASTOP', 'PAI', 'RF', 'RF1', 'RF2', 'IF', 'IF1', 'IF2', 'IF3'].includes(extraId)
}

export function padZero(value) {
  if(!value || isNaN(parseInt(value))) return value
  return Number(value) < 10 ? `0${Number(value)}` : value
}

export const PORTUGAL_COUNTRY_ID = '33'

export function isPortugalCountryId(id) { return id === PORTUGAL_COUNTRY_ID }

export function buildFieldsValidationErrors(validationsArray) {
  return validationsArray.filter(v => !v.isValid)
}

export const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

export function useUrlQuery() {
  return new URLSearchParams(window.location.search)
}

export function fileDownload(data, filename, mime, bom) {
  var blobData = (typeof bom !== 'undefined') ? [bom, data] : [data]
  var blob = new Blob(blobData, {type: mime || 'application/octet-stream'});
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // IE workaround for "HTML7007: One or more blob URLs were
      // revoked by closing the blob for which they were created.
      // These URLs will no longer resolve as the data backing
      // the URL has been freed."
      window.navigator.msSaveBlob(blob, filename);
  }
  else {
      var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename);

      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
      }

      document.body.appendChild(tempLink);
      tempLink.click();

      // Fixes "webkit blob resource error 1"
      setTimeout(function() {
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
      }, 200)
  }
}

export function hasAtLeastXDigits(str, x) {
  const digitPattern = /\d/g;
  const matches = str.match(digitPattern);
  return matches && matches.length >= x;
}

export function isTestsEnv() {
  return process.env.REACT_APP_WEB_API_URL.includes(':9443') 
    || process.env.REACT_APP_WEB_API_URL.includes(':8443') 
}

export function getLocalTimeZone() {
  return 'Europe/Lisbon' // Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function useDebouncedValue(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value)
  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value)
      }, delay)
      return () => {
        clearTimeout(handler)
      }
    },
    [value, delay]
  )
  return debouncedValue
}

export function buildMomentFromDateString(date) {
  if (!date) return moment()
  return moment(date, "YYYY-MM-DD");
}

export function isValidPlateNumber(plate) {
  return plate && ((plate.length === 6 && !plate.includes('-')) || (plate.length === 8 && plate.split('-').length - 1 === 2))
}

export function isElectric(fuel) {
  return fuel?.toLowerCase() === 'electric';
}
